import tauriConfig from '../src-tauri/tauri.conf.json';

export const APP_NAME = "Mignon UI";
export const DB_NAME = "MignonUI_WebDB";
export const DB_KEY = "data.db";
export const LOCAL_STORAGE_PREFIX = "mignon";
export const APP_VERSION = tauriConfig.version;
